import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "../locales/en.json";
import de from "../locales/de.json";

export const I18N_STORAGE_KEY = "shopvibes-lang";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
    },
    fallbackLng: "en",
    defaultNS: "translation",
    ns: ["translation"],
    keySeparator: ".",
    supportedLngs: ["en", "de"],
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: I18N_STORAGE_KEY,
    },
  });

// Persist language on every change so it survives navigation and reloads
i18n.on("languageChanged", (lng) => {
  if (typeof window !== "undefined" && lng) {
    try {
      window.localStorage.setItem(I18N_STORAGE_KEY, lng);
    } catch (_) {}
  }
});

export default i18n;
